import { createFileRoute, Outlet } from '@tanstack/react-router'
import * as v from 'valibot'
import { IntegrationsPending } from './-components/settings/account-pending'

export const Route = createFileRoute('/_app/account/integrations')({
  validateSearch: v.object({
    email: v.optional(v.pipe(v.string(), v.email())),
    p: v.optional(v.number(), 0),
  }),
  component: RouteComponent,
  pendingComponent: IntegrationsPending,
})

function RouteComponent() {
  // The guide, or one integration's pages (`$appId`); the bare path redirects to the guide.
  return <Outlet />
}
